import React from 'react';

import BaseModel from "../base_model.js.jsx";
import I18n from "../../base/i18n.js.jsx";

import InvestmentStatusEnum from "../../enums/investment_status.js.jsx";
import InvestmentActivityStatusEnum from "../../enums/investment_activity_status.js.jsx";

import MoneyFormatter from "../../utils/money_formatter.js.jsx";

import TextCell from "../../base/table/cells/text_cell.js.jsx";
import BooleanCell from "../../base/table/cells/boolean_cell.js.jsx";

import { ProjectModel } from "./project_model.js.jsx";
import UserInfoCell from '../../base/table/cells/special_cells/user_info_cell.js.jsx';
import FileCell from '../../base/table/cells/special_cells/file_cell.js.jsx';
import PaymentMethodCell from "../../base/table/cells/special_cells/payment_method_cell.js.jsx";
import ModelCell from "../../base/table/cells/model_cell.js";

import Routes from "../../admin/routes.js.jsx";

class RawProjectInvestmentModel extends BaseModel {

  rawListFilters() {
    return [
      {
        name: "statuses",
        displayName: this.fieldDisplayName("status"),
        type: "enum",
        enum: InvestmentStatusEnum,
        allowClear: true,
        clearItem: I18n.t("enum.investment_status.all"),
        multiple: true
      }
    ]
  }

  rawListFields() {
    return [
      {
        name: "participantProject",
        displayName: this.fieldDisplayName("participantProject"),
        renderFunction: (investment, column, onChangeColumn) => {
          if(investment.hideProjectInfo) {
            return <div/>
          }
          const projectColumn = {
            ...column,
            type: "model",
            model: ProjectModel,
            urlFunc: Routes.project
          }

          let project;
          if(investment.participantProject) {
            project = investment.participantProject;
          }
          else {
            const participant = investment.participant || {};
            project = participant.project;
          }

          return <ModelCell column = { projectColumn }
                            value = { project }
                            onChange = { onChangeColumn } />
        }
      },
      {
        name: "user",
        displayName: this.fieldDisplayName("user"),
        renderFunction: investment => {
          if(investment.hideUserInfo) {
            return <div/>
          }
          const participant = investment.participant || {};
          const { user } = participant;
          return <UserInfoCell user = { user } />
        }
      },
      {
        name: "contract",
        displayName: this.fieldDisplayName("contract"),
        renderFunction: investment => {
          const contractPdf = investment.contractPdf || {};
          return <FileCell file = { contractPdf } />
        }
      },
      {
        name: "isUserIdentified",
        displayName: this.fieldDisplayName("isUserIdentified"),
        renderFunction: (investment, column) => {
          if(investment.hideUserInfo) {
            return <div/>
          }
          const participant = investment.participant || {};
          const { user: { isIdentified } = {} } = participant;
          const isIdentifiedColumn = {
            ...column,
            type: "text",
          }
          return <BooleanCell column = { isIdentifiedColumn }
                              value = { isIdentified } />
        }
      },
      {
        name: "status",
        displayName: this.fieldDisplayName("status"),
        type: "enum",
        enum: InvestmentStatusEnum
      },
      {
        name: "bonuscode",
        displayName: this.fieldDisplayName("bonuscode"),
        type: "text"
      },
      {
        name: "taxId",
        displayName: this.fieldDisplayName("taxId"),
        renderFunction: (investment, column) => {
          return <TextCell column = { column } value = { investment.participant.user.personalInfo.taxId } />
        }
      },
      {
        name: "activityStatus",
        displayName: this.fieldDisplayName("activityStatus"),
        type: "enum",
        enum: InvestmentActivityStatusEnum
      },
      {
        name: "amount",
        displayName: this.fieldDisplayName("amount"),
        renderFunction: (investment, column, onChangeColumn) => {
          const amountColumn = {
            ...column,
            type: "text",
          }
          let { amount } = investment;
          if(amount) {
            amount = `${MoneyFormatter.format(amount)} ${I18n.t("currency.euro")}`
          }
          return <TextCell column = { amountColumn }
                           value = { amount }
                           onChange = { onChangeColumn } />
        }
      },
      {
        name: "calculatedInterest",
        displayName: this.fieldDisplayName("calculatedInterest"),
        renderFunction: (investment, column, onChangeColumn) => {
          const calculatedInterestColumn = {
            ...column,
            type: "text",
          }
          let { calculatedInterest, activityStatus } = investment;
          if(activityStatus === "canceled") {
            return <TextCell column = { calculatedInterestColumn }
                             value = { "-" }
                             onChange = { onChangeColumn } />
          }
          if(calculatedInterest) {
            calculatedInterest = `${MoneyFormatter.format(calculatedInterest)} ${I18n.t("currency.euro")}`
          }
          return <TextCell column = { calculatedInterestColumn }
                           value = { calculatedInterest }
                           onChange = { onChangeColumn } />
        }
      },
      {
        name: "paymentMethod",
        displayName: this.fieldDisplayName("paymentMethod"),
        renderFunction: investment => {
          const { paymentMethod } = investment || {};
          return <PaymentMethodCell paymentMethod = { paymentMethod} />
        }
      },
      {
        name: "transferPurpose",
        displayName: this.fieldDisplayName("transferPurpose"),
        renderFunction: (investment, column, onChangeColumn) => {
          const transferPurposeColumn = {
            ...column,
            type: "text",
          }
          const { transferPurpose } = investment || {};
          return <TextCell column = { transferPurposeColumn }
                           value = { transferPurpose }
                           onChange = { onChangeColumn } />
        }
      },
      {
        name: "createdAt",
        displayName: this.fieldDisplayName("createdAt"),
        type: "dateTime",
        dateFormat: "DD.MM.YYYY",
        timeFormat: "HH:mm"
      },
    ]
  }



  i18nScope() {
    return "model.projects.investment";
  }

}
const ProjectInvestmentModel = new RawProjectInvestmentModel();

export { RawProjectInvestmentModel, ProjectInvestmentModel }
